export default __webpack_public_path__ + "static/media/nato.9f98f879.jpg";